// extracted by mini-css-extract-plugin
export var layoutContainer = "_b1-0";
export var layoutContainerNoRounding = "_b1-6";
export var layoutContainerOpen = "_b1-5";
export var layoutContainerResizing = "_b1-1";
export var mainContent = "_b1-2";
export var resizeDivider = "_b1-3";
export var slidePanel = "_b1-4";